var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1719_6252)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.73096,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_6252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0663 15C16.9238 15 16 15.9238 16 17.0663V26.7756H27.7756V15H18.0663ZM24.4306 21.6122H19.345V20.1682H24.4354V21.6122H24.4306Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28.2196V37.9289C16 39.0714 16.9238 39.9952 18.0663 39.9952H27.7756V28.2196H16ZM24.4306 35.9452H19.345V34.5012H24.4354V35.9452H24.4306ZM24.4306 33.7136H19.345V32.2696H24.4354V33.7136H24.4306Z",
    fill: "#AB54A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9337 15H29.2245V26.7756H41.0001V17.0663C41.0001 15.9238 40.0763 15 38.9337 15ZM37.6551 21.6122H35.8318V23.4354H34.3878V21.6122H32.5646V20.1682H34.3878V18.345H35.8318V20.1682H37.6551V21.6122Z",
    fill: "#AB54A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2196 28.2196V39.9952H38.9289C40.0714 39.9952 40.9952 39.0714 40.9952 37.9289V28.2196H29.2196ZM37.4168 35.3958L36.3958 36.4168L35.1074 35.1284L33.819 36.4168L32.798 35.3958L34.0864 34.1074L32.798 32.819L33.819 31.798L35.1074 33.0864L36.3958 31.798L37.4168 32.819L36.1284 34.1074L37.4168 35.3958Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4354 20.1682H19.345V21.6122H24.4354V20.1682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4354 32.2744H19.345V33.7184H24.4354V32.2744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4354 34.506H19.345V35.95H24.4354V34.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.655 20.1682V21.6122H35.8318V23.4305H34.3878V21.6122H32.5646V20.1682H34.3878V18.345H35.8318V20.1682H37.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1332 34.1121L37.4216 35.4006L36.4006 36.4216L35.1121 35.1332L33.8237 36.4216L32.8027 35.4006L34.0911 34.1121L32.8027 32.8237L33.8237 31.8027L35.1121 33.0911L36.4006 31.8027L37.4216 32.8237L36.1332 34.1121Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1719_6252",
    x: 0.57006,
    y: 0.301017,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1719_6252"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1719_6252",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_6252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator-icon.a03316e81c378eadfdb064d1b83b0fcd.svg";
export { ForwardRef as ReactComponent };